<template>
	<v-container>
		<v-row class="contentRow">
			<v-col>
				<h1 class="mb-2">
					Comment #{{ commentID }} for transaction
					<router-link
						:to="`/trace/transactions/${transactionID}`"
					>
						#{{ transactionID }}</router-link
					>
				</h1>
				<v-banner
					style="border-bottom: hidden !important;"
					class="rounded my-1"
					color="grey lighten-2"
					light
				>
					<v-row class="ml-1">
						<h4 class="ml-1">Comment:</h4>
						<span>
							{{ data.message }}
						</span>
					</v-row>
				</v-banner>
			</v-col>
			<v-col cols="12">
				<v-btn
					color="secondary"
					align="center"
					class="mt-2"
					style="margin:5px"
					:to="backURL"
				>
					<v-icon small left>fas fa-arrow-left</v-icon>
					Back to list
				</v-btn>
				<v-btn
					color="warning"
					align="center"
					class="mt-2"
					@click="changeCommentStatus(1)"
					style="margin:5px"
					v-if="data.statusHistory[0].status === 0"
				>
					<v-icon small left>fa fa-times-circle</v-icon>
					Close comment
				</v-btn>
				<v-btn
					color="primary"
					align="center"
					class="mt-2"
					@click="changeCommentStatus(0)"
					style="margin:5px"
					v-if="data.statusHistory[0].status !== 0"
				>
					<v-icon small left>fa fa-redo-alt</v-icon>
					Reopen comment
				</v-btn>
			</v-col>
		</v-row>
		<v-row class="contentRow" align="center">
			<v-col>
				<v-card color="primary">
					<v-card-title class="text-center justify-left py-6">
						<h3 class="white--text">Comment Status</h3>
					</v-card-title>
					<v-data-table
						:loading="!data"
						theme--
						light
						:headers="headers"
						:items="data.statusHistory"
						class="light table mx-4 assessed-table"
						:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
					>
						<template v-slot:item.timestamp="{ item }">
							{{ item.timestamp | moment("DD.MM.YYYY  h:mm:ss") }}
						</template>
						<template v-slot:item.status="{ item }">
							<v-chip v-if="item.status === 0" label text-color="black" small>
								<v-icon left small>
									fas fa-ellipsis-h
								</v-icon>
								Open
							</v-chip>
							<v-chip
								v-if="item.status === 1"
								color="primary"
								label
								text-color="white"
								small
							>
								<v-icon left small>
									fas fa-check-circle
								</v-icon>
								Closed
							</v-chip>
						</template>
					</v-data-table>
					<br />
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import CommentsAPI from "../../api/trace/comments"
import LoadingState from "../../consts/LoadingState"
import { mapState } from "vuex"
export default {
	name: "CommentView",
	data() {
		return {
			commentID: null,
			transactionID: location.pathname?.split("/")?.reverse()?.[2],
			data: null,
			headers: [
				{
					text: "Comment Status",
					align: "start",
					sortable: false,
					value: "status",
					class: "secondary--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Modified By",
					value: "modifiedBy",
					sortable: false,
					class: "secondary--text"
				}
			]
		}
	},
	mounted() {
		if (this.$route.params.comment) {
			this.commentID = this.$route.params.comment
			this.getCommentDetail()
		} else {
			this.$router.push({
				name: "Transaction Details",
				params: { id: this.$route.params.id }
			})
		}
	},
	methods: {
		getCommentDetail() {
			CommentsAPI.getCommentDetails(this.transactionID, this.commentID)
				.then(data => {
					this.data = data
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		changeCommentStatus(status) {
			CommentsAPI.updateComment(this.transactionID, this.commentID, {
				status: status
			})
				.then(() => {
					this.getCommentDetail()
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Comment status was successfully updated!",
						{ root: true }
					)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		}
	},
	computed: {
		...mapState("loading", {
			loading: state => state.loading == LoadingState.LOADING
		}),
		backURL() {
			let paramID = this.$route.params.id
			return paramID
				? { name: "Transaction Details", params: { id: paramID } }
				: { name: "Comments List" }
		}
	}
}
</script>
